import { AtomEffect } from 'recoil';

/**
 * Sync the atom with localStorage
 * @param key The key to use. If undefined, one will be generated
 */
type LocalStorageEffectOptions<T> = {
  deserialize?: (rawValue: string) => T;
  serialize?: (value: T) => string;
};

const localStorageEffect =
  <T = unknown>(key?: string, options?: LocalStorageEffectOptions<T>): AtomEffect<T> =>
  ({ node, setSelf, onSet }) => {
    const resolvedKey = key ?? `ra-${node.key}`;
    const savedValue = localStorage.getItem(resolvedKey);
    if (savedValue != null) {
      if (options?.deserialize) {
        setSelf(options.deserialize(savedValue));
      } else {
        // default behavior: JSON deserialize
        setSelf(JSON.parse(savedValue) as T);
      }
    }

    onSet((newValue, _, isReset) => {
      if (isReset) {
        localStorage.removeItem(resolvedKey);
      } else if (options?.serialize) {
        localStorage.setItem(resolvedKey, options.serialize(newValue));
      } else {
        localStorage.setItem(resolvedKey, JSON.stringify(newValue));
      }
    });
  };

export default localStorageEffect;
